import { useGarageData, useModal } from 'shared/hooks';

export const useRules = () => {
  const modalRule = useModal();
  const modalException = useModal();
  const { timezone } = useGarageData();

  return { modalRule, modalException, timezone };
};
